import React from 'react'
import { Divider } from '../divider'
import { joinClassNames } from '../../utilities'
import css from './PrintFOIA.module.css'

export const PrintFOIA = ({ className }) => {
  const classes = joinClassNames(css.printFOIA, className)

  return (
    <div className={classes}>
      <h1>Requesting information about your complaint</h1>
      <p className="ds-text--lead">
        Every report we receive is important, however, not every submission
        results in an investigation.
      </p>
      <p className="ds-text--lead">
        Once submitted, we will review your complaint for relevance and
        completeness. If you have identified yourself, a reviewing official may
        contact you for further information. It is important to note that you
        might not be contacted by an investigator but that does not mean your
        complaint is not being investigated. Due to the high volume of
        complaints we receive, it is not possible to contact every complainant.
        The Hotline will not be able to confirm receipt of your complaint or
        respond to any inquiries about action taken on your complaint.
      </p>
      <p className="ds-text--lead">
        You may request information about your complaint through the OIG Freedom
        of Information Act officer (https://oig.hhs.gov/foia). Remember to
        phrase your request in terms of a search for records pertinent to your
        complaint, not status. You should wait at least six months before filing
        such a request.
      </p>
      <Divider />
    </div>
  )
}
